import { Grid,GridProps } from "@mui/material";

export type GridItemProps = GridProps

const GridItem = ({ children, ...props}: GridItemProps) => {
  return <Grid xs={12} {...{
      ...props,
    item: true,
  }}>{ children }</Grid>
}

export default GridItem